<template>

    <div id="wrapper">

				
			<form v-on:submit.prevent class="login-form">

				<img class="logo" src="~assets/img/Codium-PL-RGB-REV.png" alt="Codium" />

				<h1>Set New Password.</h1>

				<p>Please enter your new password.</p>

				<div class="form-group">
					<label class="control-label">New Password</label>
                    <input v-model="password"
                        class="form-control"
                        type="password"
                        placeholder="" name="password"
                        required=""/>
				</div><!-- /.form-group -->

				<div class="form-group">
					<label class="control-label">Repeat New Password</label>
					<input v-model="password_confirmation"
                        class="form-control"
                        type="password"
                        placeholder="" name="password_confirmation"
                        required=""/>
				</div><!-- /.form-group -->

                <ladda-button :type="''" :on-click="onReset" class="btn btn-login btn-block">Set Password</ladda-button>

				<router-link :to="{name: 'auth.login'}" class="small">Back to login.</router-link>

			</form><!-- /.login-form -->

	</div><!-- /#wrapper -->

</template>

<script>
    import LaddaButton from 'components/form/input/ladda-button.vue'
    import { notify } from 'utils'

    export default {
        components: {
            LaddaButton
        },

        data: function () {
            return {
                email: "",
                token: "",
                password: "",
                password_confirmation: ""
            }
        },
        mounted: function () {
          this.token = this.$route.query.token;
          this.email = this.$route.query.email;
        },
        computed: {
        	password_validation_rule: function() {
        		return 'required|min:5|in:' + this.password;
        	}
        },
        methods: {
            onReset: function() {
                
                var that = this

                return client({ path: 'password/reset', method:'POST', entity: {email: this.email, password:this.password, password_confirmation:this.password_confirmation, token:this.token} }).then(
                  function (response) {
                    
                    notify.success('Password successfully reset')
                    that.$router.push({ name: 'auth.login' })
                  },
                  function (response) {
  
                    if (response.status && response.status.code === 401) {
                      
                      notify.error('Sorry, you provided invalid credentials')
                    } else if (response.status.code === 422) {
                        var firstValidationIssue = response.entity.errors[Object.keys(response.entity.errors)[0]];
                      
                        notify.error(firstValidationIssue)
                    }
                  }
                )
            }
        }
    }
</script>
